import React, { useEffect, useState } from 'react';
import { useAdmin } from '../../context/AdminContext';
import { adminApi } from '../../api';
import { toast } from '../../hooks/use-toast';
import { Save } from 'lucide-react';

const SettingsAdmin = () => {
  const { settings, refreshAll } = useAdmin();
  const [form, setForm] = useState({ store_name: '', notice: '', telegram_bot_username: '', support_telegram: '' });

  useEffect(() => {
    if (settings) setForm({
      store_name: settings.store_name || '',
      notice: settings.notice || '',
      telegram_bot_username: settings.telegram_bot_username || '',
      support_telegram: settings.support_telegram || '',
    });
  }, [settings]);

  const save = async () => {
    try {
      await adminApi.updateSettings(form);
      toast({ title: 'Settings saved' });
      refreshAll();
    } catch (e) { toast({ title: 'Failed' }); }
  };

  return (
    <div className="px-8 py-6 max-w-[720px]">
      <div className="mb-4">
        <div className="text-[10px] tracking-[0.25em] text-[#5a5a5a] font-mono">STORE SETTINGS</div>
        <div className="text-2xl text-[#e6e6e6] font-mono">Configuration</div>
      </div>

      <div className="border border-[#151515] bg-[#0a0a0a] rounded-md p-6 font-mono space-y-4">
        <div>
          <label className="block text-[10px] tracking-[0.25em] text-[#7a7a7a] mb-1">STORE NAME</label>
          <input value={form.store_name} onChange={(e) => setForm({ ...form, store_name: e.target.value })} className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2 text-sm text-[#e6e6e6] outline-none focus:border-[#22c55e]" />
        </div>
        <div>
          <label className="block text-[10px] tracking-[0.25em] text-[#7a7a7a] mb-1">NOTICE (shown to users)</label>
          <textarea value={form.notice} onChange={(e) => setForm({ ...form, notice: e.target.value })} rows={3} className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2 text-sm text-[#e6e6e6] outline-none focus:border-[#22c55e] resize-none" />
        </div>
        <div>
          <label className="block text-[10px] tracking-[0.25em] text-[#7a7a7a] mb-1">TELEGRAM BOT USERNAME (shown in login screen)</label>
          <input value={form.telegram_bot_username} onChange={(e) => setForm({ ...form, telegram_bot_username: e.target.value })} placeholder="@yourbot" className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2 text-sm text-[#e6e6e6] outline-none focus:border-[#22c55e]" />
        </div>
        <div>
          <label className="block text-[10px] tracking-[0.25em] text-[#7a7a7a] mb-1">SUPPORT TELEGRAM (contact link)</label>
          <input value={form.support_telegram} onChange={(e) => setForm({ ...form, support_telegram: e.target.value })} placeholder="@yoursupport" className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2 text-sm text-[#e6e6e6] outline-none focus:border-[#22c55e]" />
        </div>
        <button onClick={save} className="mt-2 px-5 py-2 rounded-md text-[11px] tracking-[0.25em] bg-[#166534] hover:bg-[#15803d] text-[#e7ffef]"><Save size={12} className="inline mr-1" /> SAVE SETTINGS</button>
      </div>

      <div className="mt-6 border border-[#151515] bg-[#0a0a0a] rounded-md p-6 font-mono">
        <div className="text-[10px] tracking-[0.25em] text-[#5a5a5a] mb-3">TELEGRAM NOTIFICATIONS</div>
        <p className="text-[12px] text-[#8a8a8a] leading-relaxed">
          To receive real-time alerts for new orders and deposits on Telegram, set the following in
          <code className="text-[#22c55e] mx-1">backend/.env</code>:
        </p>
        <pre className="mt-3 bg-[#050505] border border-[#151515] rounded-md p-3 text-[11px] text-[#22c55e] overflow-x-auto">{`TELEGRAM_BOT_TOKEN="<from @BotFather>"
TELEGRAM_ADMIN_CHAT_ID="<from @userinfobot>"`}</pre>
        <p className="text-[11px] text-[#7a7a7a] mt-2">Then restart backend: <code className="text-[#22c55e]">sudo supervisorctl restart backend</code></p>
      </div>
    </div>
  );
};

export default SettingsAdmin;
